export const ORDR_FORMS: any[] = [
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "communicationEventId", "subject" ]
        } ],
        "columns" : [ {
            "name" : "orderId",
            "title" : "Order ID"
        }, {
            "name" : "communicationEventId",
            "title" : "Communication Event ID"
        }, {
            "name" : "subject",
            "title" : "Subject"
        } ],
        "formName" : "ListCommunicationByOrder",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "WSCO10731",
            "title" : "Order ID",
            "type" : "HYPERLINK",
            "target" : "/ordermgr/control/orderview?orderId=WSCO10731",
            "name" : "orderId",
            "width" : "",
            "parameterList" : [ ],
            "style" : "",
            "id" : "ListCommunicationByOrder_orderId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Communication Event ID",
            "type" : "HYPERLINK",
            "target" : "ViewCommunicationEvent",
            "name" : "communicationEventId",
            "width" : "",
            "parameterList" : [ {
            "name" : "communicationEventId"
            } ],
            "style" : "",
            "id" : "ListCommunicationByOrder_communicationEventId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Subject",
            "type" : "HYPERLINK",
            "target" : "ViewCommunicationEvent",
            "name" : "subject",
            "width" : "",
            "parameterList" : [ {
            "name" : "communicationEventId"
            }, {
            "name" : "partyId"
            }, {
            "name" : "roleTypeId"
            } ],
            "style" : "",
            "id" : "ListCommunicationByOrder_subject",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        } ],
        "target" : ""

    }   
]
